import graphql from "babel-plugin-relay/macro";
import { Hideable_configuration } from "generatedQueries/Hideable_configuration.graphql";
import React, { FC } from "react";
import { createFragmentContainer } from "react-relay";

interface IProps {
    field: HideableFields;
}

interface IGraphProps {
    configuration: Hideable_configuration | null;
}

type Props = IProps & IGraphProps;

export enum HideableFields {
    canDiscloseToPublic = "Account.CanDiscloseToPublic",
    dateOfBirth = "Account.DateOfBirth",
    driverLicence = "Account.DriverLicence",
    isSubscribedToShelterNewsletter = "Account.IsSubscribedToShelterNewsletter",
    rabiesVaccination = "Animal.RabiesVaccination",
}

export function IsHiddenField(field: HideableFields, hiddenFields: string) {
    const hiddenFieldsArray = hiddenFields.split(",").map(f => f.trim());
    const fieldIsHidden = hiddenFieldsArray.indexOf(field) > -1 || hiddenFieldsArray.indexOf(field.substring(field.indexOf(".") + 1)) > -1;
    return fieldIsHidden;
}

export const Hideable: FC<Props> = ({
    configuration,
    field,
    children,
}) =>
    <>
        {configuration && !IsHiddenField(field, configuration.hiddenFields) && children}
    </>;

export const HideableContainer = createFragmentContainer(Hideable, {
    configuration: graphql`
        fragment Hideable_configuration on Configuration {
            hiddenFields
        }`,
});
